import { Modal } from '~/components/Modal'

type Props = {
  loading: boolean
}

export const LoadingModal: React.FC<Props> = ({ loading }) => {
  return (
    <Modal visible={loading}>
      <div className='flex flex-col gap-4 items-center justify-center'>
        <h3 className='text-xl'>Buscando dados do plano...</h3>
        <div
          className='h-10 w-10 border-[6px] border-gpa-blue-500
        border-b-slate-200 rounded-full animate-spin'
        ></div>
      </div>
    </Modal>
  )
}
